import { Badge } from '@playbooks/ui/components/badge';

import { IndexSplashForm } from 'mkt/index/index-splash-form';
import { IndexSplashProof } from 'mkt/index/index-splash-proof';

const IndexSplashHero = ({ contacts = [] }) => {
	// Render
	return (
		<section className='hero-grid hero-grid-index relative flex h-full w-full grow flex-col bg-canvas'>
			<div className='flex-middle z-1 h-full w-full grow pb-16'>
				<div className='mx-auto w-full max-w-3xl px-4 text-center'>
					<div className='relative w-full text-center flex-column gap-3'>
						<div className='flex-middle'>
							<Badge className='rounded-full' variant='active'>
								Early access
							</Badge>
						</div>
						<h1 className='type-display text-white leading-tighter'>
							Transform ideas into <span className='leading-relaxed text-foreground-body'>products.</span>
						</h1>
						<p className='mx-auto max-w-2xl font-light text-foreground-body'>
							We're building an AI-native platform that helps entrepreneurs, business owners, and operators transform
							ideas into intelligent products.
						</p>
						<div className='mx-auto w-full max-w-2xl flex-column gap-2'>
							<IndexSplashForm />
							<IndexSplashProof contacts={contacts} />
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};
export { IndexSplashHero };
